/* product-oil-hero-r45.js — the round-45/46b oil hero, presentation only.

   THIS FILE NEVER TOUCHES THE CART. assets/pdp-atc.js owns the money path: it
   reads the checked `#packs .pack input[data-vid]`, honours the server-written
   `disabled`, posts the add, and repaints #atcprice and #sbprice. All this file
   does is keep the receipt row and the selected-tile class in step with the
   radio the shopper actually picked. If it fails to load, the page still sells:
   the server renders the default tier's receipt row and the button works.

   WHY THE DEFERRED SECOND PAINT. When the default tier is sold out, pdp-atc.js
   moves `checked` to the first available radio by assignment — which fires no
   change event. Painting once more on the next task picks that up whichever
   order the two scripts happen to run in. */
(function () {
  /* Anchor on #packs, not on .r45o: the proof band is a SECOND .r45o element on
     three of the four pages (it needs the same palette variables), and scoping
     to the first one found would be a coin toss. */
  var packs = document.getElementById('packs');
  if (!packs) return;
  var scope = packs.closest('.r45o');
  if (!scope) return;

  /* querySelectorAll, not querySelector: the price appears twice on a narrow
     screen — once in the receipt row and once in the mobile price line that
     rises to the title when the layout goes single-column. */
  function all(sel) { return [].slice.call(scope.querySelectorAll(sel)); }
  var titles = all('[data-r45o-rtitle]');
  var metas = all('[data-r45o-rmeta]');
  var prices = all('[data-r45o-rprice]');
  var sizes = all('[data-r45o-rsize]');
  var radios = [].slice.call(packs.querySelectorAll('.pack input[data-vid]'));
  if (!radios.length) return;

  function write(nodes, value) {
    if (!value) return;
    nodes.forEach(function (n) { n.textContent = value; });
  }

  function paint() {
    var checked = null;
    radios.forEach(function (r) {
      var tile = r.closest('.pack');
      if (tile) tile.classList.toggle('on', r.checked);
      if (r.checked) checked = r;
    });
    if (!checked) return;
    /* Each string is written by Liquid onto the radio, so every figure here was
       computed from a real variant price in the shopper's own currency. Nothing
       is formatted, parsed or arithmetic'd in the browser. */
    write(titles, checked.getAttribute('data-receipt-title'));
    write(metas, checked.getAttribute('data-receipt-meta'));
    write(prices, checked.getAttribute('data-price'));
    write(sizes, checked.getAttribute('data-receipt-size'));
  }

  radios.forEach(function (r) { r.addEventListener('change', paint); });
  paint();
  setTimeout(paint, 0);

  /* The standalone page's real <form> is guarded INLINE, in the section, right
     under the form itself — not here. A deferred file is the wrong place for
     it: if this asset failed to load while pdp-atc.js succeeded, the drawer
     would add one unit and the native post a second. See the comment in
     sections/product-myrrh-oil-r45.liquid. */

  /* THE THUMBNAIL GALLERY IS GONE FROM THIS FILE (2026-09-12). Myrrh was the
     last page on the store with a gallery engine of its own — this block held
     its swap, its arrows and its edge stops, against data-r45o-main /
     data-r45o-thumb / data-r45o-prev / data-r45o-next. The page renders
     snippets/pdp-gallery now and assets/pdp-gallery.js drives it, the same
     engine jade oil, rose otto and inner sanctum already ran. Nothing else in
     this file changed: the receipt row above still serves all four oils. */
})();
